export default __webpack_public_path__ + "static/media/img-0184-ireland-full-face.d05a8394.png";